//  This generic modal can be used to display simple data that doesn't require additional actions in the component.  It will display any title/body passed
//  through, the buttons can be customized to show one or two, and the okButton can be changed to the danger color for destructive actions.
import { Component, Input } from '@angular/core';
import { LoggerService, LogCategory, LogType, LogCoreComponent } from 'src/app/core/services/logger.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from '../../services/profile.service';

@Component({
    selector: 'display-details-modal',
    templateUrl: './display-details.component.html',
    standalone: false
})
export class DisplayDetailsModalComponent {
    @Input() title: string;
    @Input() body: string;
    @Input() okButton: string = "Ok";
    @Input() cancelButton: string = "Cancel";
    @Input() useTwoButtons: boolean = false;  //  If this is false only the okButton is shown
    @Input() useDangerColor: boolean = false; //  This controls the color of the okButton

    constructor(
        private logger: LoggerService,       
        public activeModal: NgbActiveModal,
        public profileService: ProfileService,
    ) {
        this.log("constructor", "", LogCategory.Constructor);
    }
          
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.CoreComponent, LogCoreComponent.Modal, category);
    }   
}
